import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RecommendationService } from './../../recommendation/recommendation.service';
import { _ } from 'underscore';
import { ResidentialService } from '../../residential.service';

@Component({
  selector: 'app-ssn-check',
  templateUrl: './ssn-check.component.html',
  styleUrls: ['./ssn-check.component.css'],
})
export class SsnCheckComponent implements OnInit {
  selectedProduct;
  ssnFailedEnergyProvidersList;
  providerContact;
  constructor(
    private router: Router,
    private recommendationService: RecommendationService,
    private residentialService: ResidentialService
  ) {
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    if (!_.isEmpty(this.recommendationService.ssnFailedEnergyProviders)) {
      this.ssnFailedEnergyProvidersList =
        this.recommendationService.ssnFailedEnergyProviders;
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.ssnFailedEnergyProvidersList)
      );
    } else {
      this.ssnFailedEnergyProvidersList = JSON.parse(
        sessionStorage.getItem('ssnFailedEnergyProviders')
      );
    }
  }

  ngOnInit() {}
  shop(selectedOption) {
    if (selectedOption === 'prepaid') {
      this.recommendationService.ssnFailedText = selectedOption;
      sessionStorage.setItem(
        'ssnFailedText',
        this.recommendationService.ssnFailedText
      );
      if (!_.isEmpty(this.ssnFailedEnergyProvidersList)) {
        this.recommendationService.ssnFailedEnergyProviders = [];
        sessionStorage.setItem(
          'ssnFailedEnergyProviders',
          JSON.stringify(this.recommendationService.ssnFailedEnergyProviders)
        );
      }
    } else {
      this.recommendationService.ssnFailedText = selectedOption;
      if (!_.isEmpty(this.ssnFailedEnergyProvidersList)) {
        this.recommendationService.ssnFailedEnergyProviders =
          this.ssnFailedEnergyProvidersList;
      }
      this.recommendationService.ssnFailedEnergyProviders.push(
        this.selectedProduct.energy_provider
      );
      sessionStorage.setItem(
        'ssnFailedText',
        this.recommendationService.ssnFailedText
      );
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.recommendationService.ssnFailedEnergyProviders)
      );
    }
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }
}
